module.exports = __webpack_public_path__ + "static/media/down_arrow.37410702.svg";